import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { searchProduct } from '../helpers/apiCalls';
import { useEffect } from 'react';
import { CircularProgress, InputAdornment } from '@mui/material';
import palette from '../theme/palette';

export default function SearchAppBar(props) {
  const [query, setQuery] = useState('')
  const [titleResults, setTitleResults] = useState({ docs: [] })
  const [idResults, setIdResults] = useState({ docs: [] })
  const [loading, setLoading] = useState(false)

  const [idSignal, setIdSignal] = useState(null)
  const [titleSignal, setTitleSignal] = useState(null)

  const getProductById = async () => {
    idSignal?.abort();

    const newIdSignal = new AbortController();
    setIdSignal(newIdSignal);
    const signal = newIdSignal.signal;

    let response = await searchProduct(encodeURIComponent(query), signal, false);

    if (response.status === 200) {
      setIdResults(response.data)
    }
  }

  const getProductByTitle = async () => {
    titleSignal?.abort();

    const newTitleSignal = new AbortController();
    setTitleSignal(newTitleSignal);
    const signal = newTitleSignal.signal;

    let response = await searchProduct(encodeURIComponent(query), signal, true);

    if (response.status === 200) {
      setTitleResults(response.data)
    }
  }

  const handleSearch = async () => {
    setLoading(true);
    await getProductById();
    await getProductByTitle();
    setLoading(false);
  }

  const combineResults = () => {
    let finalResults = []

    titleResults.docs.forEach(title => {
      if (!finalResults.find(result => result.id === title.id)) {
        finalResults.push(title);
      }
    })

    idResults.docs.forEach(title => {
      if (!finalResults.find(result => result.id === title.id)) {
        finalResults.push(title);
      }
    })

    return finalResults;
  }

  useEffect(() => {
    if (query.length > 0) {
      handleSearch()
    }
  }, [query])

  useEffect(() => {
    props.setResults(combineResults())
  }, [idResults, titleResults])

  return (
    <InputBase
      placeholder="Search…"
      inputProps={{ 'aria-label': 'search' }}
      startAdornment={<InputAdornment position='start' sx={{ color: palette.text.primary }}><SearchIcon /></InputAdornment>}
      endAdornment={loading ? <InputAdornment position='end'><CircularProgress size={24} /></InputAdornment> : ''}
      onChange={event => setQuery(event.target.value)}
      onKeyDown={async (e) => {
        if (['Enter', 'NumpadEnter'].includes(e.key) && query !== '') {
          handleSearch()
        }
      }}
      autoFocus
      sx={{
        width: '100%',
        padding: 1
      }}
    />
  );
}